import { Rating } from '@care/react-component-lib';
import { Grid, useMediaQuery, Typography, type Theme } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider as SEOSegmentationProvider } from '@/__generated__/getSearchResults';

export interface ProviderRatingProps {
  avgReviewRating: NonNullable<SEOSegmentationProvider['provider']['avgReviewRating']>;
  numberOfReviews: SEOSegmentationProvider['numberOfReviews'];
}

export const ProviderRating = ({ avgReviewRating, numberOfReviews }: ProviderRatingProps) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  return (
    <Grid
      item
      container
      alignItems={isMobileOrSmaller ? 'center' : 'flex-end'}
      alignContent="center"
      justifyContent="flex-end"
      spacing={isMobileOrSmaller ? 2 : 0}>
      <Grid item>
        <Typography variant={isMobileOrSmaller ? 'h1' : 'display3'} component="span">
          {avgReviewRating.toFixed(1)}
        </Typography>
      </Grid>
      <Grid
        container
        item
        xs
        sm={12}
        spacing={1}
        justifyContent={isMobileOrSmaller ? 'flex-start' : 'flex-end'}
        alignItems="center">
        <Grid item>
          <Rating
            name="size-medium"
            size="medium"
            defaultValue={avgReviewRating}
            readOnly
            sx={{ display: 'flex' }}
          />
        </Grid>
        <Grid item>
          <Typography variant="body2">({numberOfReviews})</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
